// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3GImr","errorLogs":"styles_errorLogs__2Zn4n"};